<template>
    <div>
        <div v-if="hasFilter" id="nav-tab" role="tablist"
            class="nav nav-tabs d-flex justify-content-md-center product-tabs mb-4">
            <a  class="
                    nav-item nav-link nav-link__all
                    text-white rounded-pill
                    d-inline-flex justify-content-center align-items-center
                    py-2 px-3 mb-2 mx-1
                "
                role="tab">
                {{ $t('site.products-filter-by-applications') }}</a>

            <a  v-for="apl in topApplications"
                v-on:click="() => toggleApplication(apl)"
                :key="apl.id"
                :class="[
                    'nav-item', 'nav-link',
                    'rounded-pill',
                    'mx-1', 'd-inline-flex',
                    'justify-content-center',
                    'align-items-center',
                    'py-2', 'px-3', 'mb-2',
                    selectedApplication.id == apl.id ? 'active' : '',
                ]"
                href="javascript:void(0)"
                role="tab">
                <i v-if="selectedApplication.id == apl.id"
                   class="material-icons mr-1 position-absolute">done</i>
                {{ apl.attributes.name }}
            </a>
        </div>

        <div :key="timestamp"
            class="products-carousel owl-carousel owl-carousel__show-all mb-5 px-4">
            <a  v-for="product in products"
                :href="product.attributes.path"
                class="card card__hover h-100 box-shadow">
                <div class="card--header bg-primary text-white py-2 text-left px-2">
                    <h4 class="card--header__sm m-0">{{ $t('site.products-performance-series') }}</h4>
                </div>
                    <img :src="_.imgPath(product.attributes.image, 'h325-q80')" alt="">
                <div class="card-footer text-left mt-auto">
                    <h3 class="text-uppercase mb-1">{{ product.attributes.name }}</h3>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
import UtilsMixin from './UtilsMixin';

export default {
    data() {
        return {
            selectedCategory: {},
            selectedApplication: {},
            topApplications: [],
            timestamp: Date.now(),
        }
    },

    props: ['initialData', 'config'],

    mixins: [UtilsMixin],

    created() {
        const productIds = _.chain(this.initialData)
            .get('products.data')
            .map(_.property('id'))
            .value();

        this.topApplications = _.chain(this.initialData)
            .get('applications.data')
            .map((apl) => {
                _.set(apl, 'attributes.product_list', _.get(this.initialData, ['applicationProductMap', apl.id], []));
                return apl;
            })
            .filter(apl => {
                let hasProducts = !_.chain(productIds)
                    .intersection(apl.attributes.product_list)
                    .isEmpty()
                    .value();
                return hasProducts && !apl.attributes.parent_id;
            })
            .value()
    },

    mounted() {
        this.$nextTick(() => {
            this.renderCarousel();
        })
    },

    computed: {
        products() {
            return _.chain(this.initialData)
                .get('products.data')
                .filter(p => {
                    let pass = true;
                    if (pass && !_.isEmpty(this.selectedCategory)) {
                        pass = _.chain(this.selectedCategory)
                            .get('attributes.product_list')
                            .includes(p.id)
                            .value();
                    }
                    if (pass && !_.isEmpty(this.selectedApplication)) {
                        pass = _.chain(this.selectedApplication)
                            .get('attributes.product_list')
                            .includes(p.id)
                            .value();
                    }

                    return pass;
                }).value();
        },

        categories() {
            return _.get(this.initialData, 'categories.data');
        },

        hasFilter() {
            return !_.isEmpty(this.topApplications);
        },
    },

    methods: {
        toggleCategory(cat) {
            if (this.selectedCategory && this.selectedCategory.id == cat.id) {
                this.selectedCategory = null;
            } else {
                this.selectedCategory = cat;
            }
        },

        toggleApplication(apl) {
            if (this.selectedApplication && this.selectedApplication.id == apl.id) {
                this.selectedApplication = {};
            } else {
                this.selectedApplication = apl;
            }

            this.timestamp = Date.now();
            this.$nextTick(() => {
                this.renderCarousel();
            });
        },

        renderCarousel() {
            $('.products-carousel').owlCarousel({
                responsiveRefreshRate: 1,
                loop: false,
                margin: 24,
                responsiveClass: true,
                items: 1,
                nav: false,
                navText: [""],
                dots: false,
                dotsEach: true,
                autoplay: false,
                autoplayTimeout: 1000,
                smartSpeed: 750,
                responsive: {
                    576: {
                        items: 2
                    },
                    768: {

                        nav: true,
                        items: 2,
                    },
                    992: {
                        items: 3,
                        nav: true,
                    },
                    1800: {
                        items: 5,
                        nav: true,
                    },
                }
            })
        }
    }
}
</script>
